import { styled } from '@mui/material/styles';
import { Widget, WidgetHeaderContainer } from './Widget';

//Force consistent height (probably to change in future to for example pass some value)
const HEDER_HEIGHT = 30;

export const UsageWidget = styled(Widget)(() => ({
  [`& ${WidgetHeaderContainer}`]: {
    height: HEDER_HEIGHT,
  },
}));

export const UsageWidgetLegend = styled('div')({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  transform: 'translateY(-100%)',
  top: -16,
  right: 0,
  gap: 16,
  height: HEDER_HEIGHT,
});
